<article class="legal-page" aria-labelledby="privacy-title">
  <header class="legal-header">
    <h1 id="privacy-title">Política de privacidad</h1>
    <p class="legal-intro">
      Esta política explica cómo se tratan los datos enviados mediante el formulario de contacto y
      los canales de comunicación de ATSIestudio.
    </p>
  </header>

  <nav class="legal-index" aria-label="Contenido de la política de privacidad">
    <h2>Contenido</h2>
    <ol>
      <li><a href="#responsable">Responsable</a></li>
      <li><a href="#datos">Datos tratados</a></li>
      <li><a href="#finalidades">Finalidades y legitimación</a></li>
      <li><a href="#conservacion">Conservación</a></li>
      <li><a href="#proveedores">Destinatarios y proveedores</a></li>
      <li><a href="#derechos">Derechos</a></li>
    </ol>
  </nav>

  <section id="responsable" aria-labelledby="controller-title">
    <h2 id="controller-title">1. Responsable del tratamiento</h2>
    <dl class="legal-data">
      <div>
        <dt>Responsable</dt>
        <dd>ATSIestudio</dd>
      </div>
      <div>
        <dt>Contacto</dt>
        <dd><a href="mailto:contacto@atsiestudio.com">contacto@atsiestudio.com</a></dd>
      </div>
    </dl>
  </section>

  <section id="datos" aria-labelledby="data-title">
    <h2 id="data-title">2. Qué datos se tratan</h2>
    <p>
      El formulario solicita únicamente los datos necesarios para estudiar y responder la consulta:
    </p>
    <ul>
      <li>nombre, correo electrónico y teléfono, cuando este último se facilite;</li>
      <li>empresa, cuando se facilite voluntariamente;</li>
      <li>tipo de proyecto y contenido del mensaje;</li>
      <li>confirmación de lectura y aceptación de la política de privacidad;</li>
      <li>
        datos técnicos imprescindibles para la seguridad y prevención de envíos automatizados.
      </li>
    </ul>
    <p>
      No deben enviarse categorías especiales de datos, contraseñas ni información confidencial que
      no sea necesaria para una primera consulta.
    </p>
  </section>

  <section id="finalidades" aria-labelledby="purposes-title">
    <h2 id="purposes-title">3. Finalidades y base jurídica</h2>
    <h3>Responder consultas y solicitudes de presupuesto</h3>
    <p>
      Los datos se utilizarán para analizar la necesidad planteada, contactar con la persona
      interesada y, cuando proceda, preparar una propuesta. La base jurídica será el consentimiento
      manifestado al enviar el formulario y, cuando la solicitud busque contratar un servicio, la
      aplicación de medidas precontractuales solicitadas por la persona interesada.
    </p>
    <h3>Seguridad y prevención del abuso</h3>
    <p>
      Se aplican validaciones técnicas, un campo trampa, controles temporales y Cloudflare Turnstile
      para proteger el formulario. La base jurídica prevista es el interés legítimo en mantener el
      servicio seguro y prevenir usos fraudulentos.
    </p>
    <h3>Analítica opcional</h3>
    <p>
      Con autorización previa, Google Analytics permite elaborar estadísticas agregadas de
      navegación y conversiones. No se envían los datos introducidos en el formulario. La base
      jurídica es el consentimiento, que puede retirarse desde “Configurar privacidad” en el pie de
      página.
    </p>
    <p>
      No se utilizarán los datos del formulario para enviar comunicaciones comerciales no
      solicitadas.
    </p>
  </section>

  <section id="conservacion" aria-labelledby="retention-title">
    <h2 id="retention-title">4. Conservación</h2>
    <p>
      El formulario no guarda las solicitudes en una base de datos propia: las remite al buzón de
      contacto. Los mensajes se conservarán durante 1 año, o durante el tiempo necesario para
      atender la consulta y cumplir las obligaciones legales que puedan derivarse.
    </p>
  </section>

  <section id="proveedores" aria-labelledby="providers-title">
    <h2 id="providers-title">5. Destinatarios, proveedores y transferencias</h2>
    <p>No se venderán ni cederán los datos a terceros con fines comerciales.</p>
    <p>Para prestar y proteger el servicio intervienen los siguientes proveedores tecnológicos:</p>
    <ul>
      <li>
        <strong>OVHcloud y Coolify:</strong> infraestructura y despliegue de la web y del endpoint
        del formulario.
      </li>
      <li><strong>Resend:</strong> entrega del mensaje al buzón de contacto.</li>
      <li>
        <strong>Cloudflare Turnstile:</strong> detección de tráfico automatizado y validación
        antispam.
      </li>
      <li>
        <strong>Google Analytics:</strong> estadísticas de navegación y conversiones, únicamente
        después de aceptar la analítica.
      </li>
    </ul>
  </section>

  <section id="derechos" aria-labelledby="rights-title">
    <h2 id="rights-title">6. Derechos de las personas</h2>
    <p>
      Se puede solicitar acceso, rectificación, supresión, oposición, limitación o portabilidad de
      los datos, así como retirar el consentimiento sin afectar a la licitud del tratamiento previo,
      escribiendo a <a href="mailto:contacto@atsiestudio.com">contacto@atsiestudio.com</a>. Será
      necesario aportar información suficiente para identificar la solicitud.
    </p>
    <p>
      Si se considera que el tratamiento no se ajusta a la normativa, puede presentarse una
      reclamación ante la
      <a href="https://www.aepd.es/" target="_blank" rel="noreferrer"
        >Agencia Española de Protección de Datos</a
      >.
    </p>
  </section>

  <section aria-labelledby="security-title">
    <h2 id="security-title">7. Seguridad y actualizaciones</h2>
    <p>
      Se aplican medidas técnicas y organizativas proporcionadas al riesgo. Ningún sistema conectado
      a Internet permite garantizar seguridad absoluta, por lo que las medidas se revisarán cuando
      cambien el formulario, los proveedores o el tratamiento.
    </p>
    <p>
      La información específica sobre tecnologías del navegador está disponible en la
      <a routerLink="/cookies">política de cookies</a>.
    </p>
  </section>

  <footer class="legal-update">
    <p><strong>Última actualización:</strong> 12 de agosto de 2026.</p>
  </footer>
</article>
